var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-tab",class:{ 'selected' : this.isSelected },attrs:{"id":_vm.id}},[(this.isSelected)?_c('div',{staticClass:"content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }